import { useEffect, useState } from 'react'

import { CLOCK_BUCKET_MS } from './selectors'

/**
 * «Сейчас» для причин зависания чека («Ждём 3 мин») и срока повтора («Доступно через 2 мин»): значение меняется раз в период, и вместе
 * с ним пересчитывается vm окна. Окно скрыто — таймер не нужен: при возврате вкладки значение обновляется сразу.
 */
export function useClockBucket(periodMs: number = CLOCK_BUCKET_MS): number {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const refresh = () => setNow(Date.now())
    const timer = setInterval(() => {
      if (document.visibilityState === 'visible') refresh()
    }, periodMs)
    document.addEventListener('visibilitychange', refresh)
    return () => {
      clearInterval(timer)
      document.removeEventListener('visibilitychange', refresh)
    }
  }, [periodMs])
  return now
}
